import { useTranslation } from "react-i18next"

import LegalPageContent from "../components/LegalPageContent/LegalPageContent"
import SEO from "../components/SEO/SEO"
import useSiteTitle from "../hooks/use-site-title"

const TermsOfUse = () => {
  const { t, i18n } = useTranslation()

  const title = t("Terms of Use")

  const siteTitle = useSiteTitle(false)

  return (
    <LegalPageContent>
      <SEO title={title} description={title} siteTitle={siteTitle} />
      {i18n.language === "es" ? (
        <div>
          <div>
              <h1><span>Aviso Legal</span>


          </h1>
              <div><div>
            <div>
            <p>A través de este Aviso Legal se regulan las Condiciones Generales de Uso del web que Ingeteam, pone a disposición pública en la presente URL.
          </p>
          <p>La utilización del contenido y/o servicios de la web por parte del usuario supone la aceptación expresa de las siguientes Condiciones Generales de Uso, así como de la Política de Protección de Datos de Carácter Personal.
          </p>
          <p><strong>Condiciones de Uso de la web</strong>
          </p>
          <p>Ingeteam se reserva el derecho de efectuar modificaciones en el contenido de esta web sin previo aviso, así como de su configuración y presentación.
          </p>
          <p>Esta web puede contener enlaces a páginas externas, no siendo Ingeteam responsable del contenido de dichas páginas externas ni de cualquier otro aspecto relacionado con las mismas.
          </p>
          <p>Para poder instalar o utilizar cualquier software que se encuentre disponible para su descarga desde esta web, deben aceptarse previamente los términos del Contrato de Licencia, si lo hubiera, que acompañe o se incluya en el software.
          </p>
          <p>Ingeteam- no se hace responsable de los posibles daños que se pudieran producir por el hecho de utilizar versiones no actualizadas de navegadores, o de las consecuencias que se pudieran derivar del mal funcionamiento del navegador, ya sea por configuración inadecuada, presencia de virus informáticos o por cualquier otra causa ajena a Ingeteam.
          </p>
          <p>Ingeteam. Se prohíbe la reproducción total o parcial del contenido de esta web sin autorización expresa de Ingeteam.
          </p>
          <p><strong>Ley aplicable y jurisdicción</strong>
          </p>
          <p>Este Aviso Legal se rige en todos y cada uno de sus extremos por la ley española, siendo competentes para la resolución de cualquier conflicto derivado o relacionado con el uso de esta web los Juzgados y Tribunales de Bilbao.<br/>
          </p>
          </div>

          </div></div>
              <div></div>
          </div>
        </div>
        ) : i18n.language === "en" ? (
          <div>
            <h1><span>Legal Notice</span>


            </h1>
                <div><div>
              <div>
              <p>This Legal Warning contains the General Terms and Conditions of use of the Ingeteam Corporación S.A. website, available for public use at this URL.
            </p>
            <p>You agree that by accessing and using this website, you will be expressly bound by the following General Terms and Conditions for use and our Data Protection and Privacy Policy.
            </p>
            <p><strong>Terms and Conditions of use of this website</strong>
            </p>
            <p>Ingeteam reserves the right to make changes to any part of this Web site, and changes to its configuration and presentation without previous notice.
            </p>
            <p>Hypertext links within the web site may cause you to leave our site and access other websites not under our control. We make no representation and provide no warranty or liability as to the content or any other aspects of such third party websites.
            </p>
            <p>To install or use any software made available to download from this website, you must first accept the terms of the Licence Contract, if any, accompanying or included in the software.
            </p>
            <p>Ingeteam is not responsible for any damage caused by using outdated versions of browsers, the consequences of browser errors, incorrect configuration, computer viruses or any other causes beyond the control of Ingeteam.
            </p>
            <p>Ingeteam. Any copying of this site (in whole or in part) is prohibited without the express, previous and written, content of Ingeteam.
            </p>
            <p><strong>Applicable law and jurisdiction</strong>
            </p>
            <p>This Legal Warning is subject in its entirety to Spanish Law, and any conflicts arising from or related to the use of this website will be definitely resolved by the Courts and Tribunals of Bilbao.
            </p>
            <p>&nbsp;
            </p>
            <p>
            </p>
        </div>
        </div></div>
            <div></div>
        </div>
        ) : ('')}
    </LegalPageContent>
  )
}

export default TermsOfUse
